import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import TokenExFrame, { TokenExFramePresentationProps } from "@insite/mobius/TokenExFrame";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import EditIcon from "@MasterBluePrint/Icons/EditIcon";
import InfoNewIcon from "@MasterBluePrint/Icons/InfoNew";
import themeColors, { themeFontSizes, themeFontWeights } from "@MasterBluePrint/Styles/variables";
import React, { useState } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

interface OwnProps {
    canSaveCard?: boolean;
    /** @deprecated Specify the "TokenEx" value for the `iframe` property instead. */
    useTokenExGateway?: boolean;
    iframe?: "TokenEx" | "Paymetric";
    paymetricFrameRef?: React.Ref<HTMLIFrameElement>;
    isTokenExIframeLoaded?: boolean;
    saveCard: boolean;
    onSaveCardChange: (_: React.SyntheticEvent<Element, Event>, value: boolean) => void;
    cardHolderName: string;
    cardHolderNameRef?: React.Ref<HTMLInputElement>;
    onCardHolderNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    cardHolderNameError?: string;
    cardNumber: string;
    cardNumberRef?: React.Ref<HTMLInputElement>;
    onCardNumberChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    cardNumberError?: string;
    cardType: string;
    cardTypeRef?: React.Ref<HTMLSelectElement>;
    possibleCardType: string;
    onCardTypeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    cardTypeError?: string;
    expirationMonth: number;
    expirationMonthRef?: React.Ref<HTMLSelectElement>;
    onExpirationMonthChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    expirationError?: string;
    expirationYear: number;
    expirationYearRef?: React.Ref<HTMLSelectElement>;
    onExpirationYearChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    securityCode: string;
    securityCodeRef?: React.Ref<HTMLInputElement>;
    onSecurityCodeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    securityCodeError?: string;
    availableCardTypes: { key: string; value: string }[];
    availableMonths: { key: string; value: number }[];
    availableYears: { key: number; value: number }[];
    extendedStyles?: CreditCardDetailsEntryStyles;
    cardModalOpen: any;
    currentUserIsGuest:any;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    return {
        cartState,        
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps> ;

export interface CreditCardDetailsEntryStyles {
    creditCardDetailsContainer?: GridContainerProps;
    creditCardDetailsHeadingGridItem?: GridItemProps;
    creditCardDetailsHeading?: TypographyPresentationProps;
    saveCardGridItem?: GridItemProps;
    saveCardCheckboxGroup?: CheckboxGroupComponentProps;
    saveCardCheckbox?: CheckboxPresentationProps;
    cardHolderNameGridItem?: GridItemProps;
    cardHolderNameText?: TextFieldPresentationProps;
    cardNumberGridItem?: GridItemProps;
    cardNumberTokenExFrameWrapper?: InjectableCss;
    cardNumberTokenExFrame?: TokenExFramePresentationProps;
    cardNumberText?: TextFieldPresentationProps;
    cardTypeGridItem?: GridItemProps;
    cardTypeTokenExLabel?: TypographyPresentationProps;
    cardTypeTokenExText?: TypographyPresentationProps;
    cardTypeSelect?: SelectPresentationProps;
    expirationDateGridItem?: GridItemProps;
    expirationDateContainer?: GridContainerProps;
    expirationMonthGridItem?: GridItemProps;
    expirationMonthSelect?: SelectPresentationProps;
    expirationYearGridItem?: GridItemProps;
    expirationYearSelect?: SelectPresentationProps;
    securityCodeGridItem?: GridItemProps;
    securityCodeTokenExFrameWrapper?: InjectableCss;
    securityCodeTokenExFrame?: TokenExFramePresentationProps;
    securityCodeText?: TextFieldPresentationProps;
    securityCodeHelpModal?: ModalPresentationProps;
    securityCodeHelpModalImageWrapper?: InjectableCss;
    securityCodeHelpImage?: LazyImageProps;
    paymetricGridItem?: GridItemProps;
    paymetricIframe?: InjectableCss;
    selectCardAddressLink?: LinkPresentationProps;
    securityLabel?: TypographyProps;
    shippingAndHandlingValue?: TypographyProps;
    tooltip?: InjectableCss;
    tooltipHeading?: InjectableCss;
    tooltipContent?: InjectableCss;
    tooltipIcon?: InjectableCss;
    titleContainer?: InjectableCss;
    selectCard?: InjectableCss;
}

export const creditCardDetailsEntryStyles: CreditCardDetailsEntryStyles = {
    creditCardDetailsContainer: { 
        gap: 10,
        css: css`
            width: 100%;
            iframe {
                width: 99.4%;
            }

            > div {
                width: 100% !important;
                margin: 0 !important;
            }
            label[class^="TypographyStyle"],label[class*="TypographyStyle"] {
                font-size: ${themeFontSizes.size14};
                font-weight: ${themeFontWeights.fontWeightMedium};
                font-family: 'Roboto',sans-serif;
                span {
                    padding-left: .9375rem;                        
                }
            }
        `,
    },
    creditCardDetailsHeadingGridItem: { 
        width: 12,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding-top: 0;
                    `,
                    null,
                    null,
                ],
                "min",
            )}
        `,
     },
    creditCardDetailsHeading: { variant: "h5" },
    saveCardGridItem: { 
        width: 12,
        css: css`
            height: inherit;
            > div {
                margin-top: -0.3125rem; 
            }
            label {
                color: ${themeColors.colorAddress} !important;
                font-family: 'Lato',sans-serif;
                font-size: ${themeFontSizes.size15};
                letter-spacing: 0.0106rem;
                font-weight: ${themeFontWeights.fontWeightRegular} !important;
            }
        `,
     },
    cardHolderNameGridItem: { width: 12 },
    cardNumberGridItem: { width: 12 },
    cardNumberTokenExFrameWrapper: {
        css: css`
            height: inherit;
        `,
    },
    cardTypeGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    cardTypeTokenExLabel: { 
        weight: 500,
        css:css`
            font-size: ${themeFontSizes.size14};
        `, 
    },
    expirationDateGridItem: { width: 12 },
    expirationDateContainer: { gap: 10 },
    expirationMonthGridItem: { 
        width: 6,
        css: css`
            @media (min-width: 990px) and (max-width: 1100px) {
                span {
                    width: 100%;
                    display: inline-block;
                }
            }
        `,
    },
    expirationYearGridItem: { 
        width: 6,
        css: css`
            @media (min-width: 990px) and (max-width: 1100px) {
                span {
                    width: 100%;
                    display: inline-block;
                }
            }
        `,
    },
    securityCodeGridItem: { 
        width: [6,6,6,6,6],
        css: css`
            width: 50%;
            label {
                > span {
                    margin-left: 1.5rem;
                }
            }
            iframe {
                width: 99% !important;
            }
            
        `,
    },
    securityCodeTokenExFrameWrapper: {
        css: css`
            height: inherit;
        `,
    },
    securityCodeHelpModalImageWrapper: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    paymetricGridItem: {
        width: 12,
    },
    paymetricIframe: {
        css: css`
            width: 100%;
        `,
    },
    selectCardAddressLink: {
        css: css`
            margin-left: 1.25rem;
            padding-left: .9375rem;
            margin-right: 0;
            border-left: 0.0625rem solid ${themeColors.colorBorderNew};
        `,
    },
    securityLabel: {
        css: css`
            position: absolute;
            font-size: ${themeFontSizes.size16};
            font-weight: ${themeFontWeights.fontWeightMedium};
            -webkit-letter-spacing: -.019rem;
            -moz-letter-spacing: -.019rem;
            -ms-letter-spacing: -.019rem;
            letter-spacing: -.019rem;
            line-height: 1.438rem;
            left: 9.125rem;
            cursor: pointer;

            @media (max-width: 990px) {
                left: 7rem;
            }
        `,
    },
    tooltipIcon: {
        css: css`
            display: inline-block;
            position: absolute;
            margin-left: 0.3125rem;
            cursor: pointer;
            z-index: 9;

            svg {
                width: 1.5rem;
                height: 1.5rem;
                scale: 0.8;
            }
        `,
    },
    tooltip: {
        css: css`
            background-color: ${themeColors.colorWhite};
            box-shadow: 0 0.4375rem 1.0625rem 0 rgba(0,37,84,0.23);
            position: absolute;
            width: 15.625rem;
            padding: 1.5625rem;
            right: auto;
            left: -5.625rem;
            bottom: 1rem;
            display: none;
            z-index: 2;

            &.active {
                display: block;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            right:-6.625rem;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    tooltipHeading: {
        css: css`
            position: relative;
            color: ${themeColors.colorPrimary};
            font-family: 'Roboto', sans-serif;
            font-size: 1.125rem;
            font-weight: ${themeFontWeights.fontWeightMedium};
            letter-spacing: 0;
            line-height: 1.9375rem;
            margin-bottom: 1.25rem;
            text-align: left;
            &:after {
                height: 0.1875rem;
                width: 0.665rem;
                background-color: ${themeColors.colorDanger};
                content: '';
                display: inline-block;
                position: absolute;
                bottom: -0.125rem;
                left: 0.0625rem;
            }
        `,
    },
    tooltipContent: {
        css: css`
            color: ${themeColors.colorMeasureText};
            font-family: 'Lato',sans-serif;
            font-size: .9375rem;
            letter-spacing: 0.0106rem;
            line-height: 1.5rem;
            text-align: left !important;

            &:after {
                content: '';
                display: block;
                height: 0;
                position: absolute;
                width: 0;
                border: 0.75rem solid;
                border-color: ${themeColors.colorWhite} transparent transparent transparent;
                z-index: 99;
                bottom: -1.4375rem;
                right: 13.250625rem;
            }
        `,
    },
    titleContainer: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            align-content: center;

            .select-card {
                color: ${themeColors.colorMidGrey};
                font-family: 'Roboto', sans-serif;
                font-size: ${themeFontSizes.size15};
                letter-spacing: 0;
                line-height: 1.3125rem;
                display: inline-block;
                vertical-align: middle;
                margin-right: .9375rem;

                @media screen and (max-width: 480px) {
                    max-width: 5.375rem;
                }
            }

            span {
                vertical-align: middle;
            }

            svg {
                width: 1.5rem;
                height: 1.5rem;
                scale: 0.8;
            }
        `,
    },
    selectCard: {
        css: css`
            width: 100%;
            flex-basis: 100%;
            max-width: 100%;
            position: relative;

            @media screen and (max-width: 990px) {
                width: 100%;
                flex-basis: 100%;
                max-width: 100%;
            }

            .card-heading {
                color: ${themeColors.colorHeadText};
                font-family: 'Roboto', sans-serif;
                font-size: ${themeFontSizes.size18};
                font-weight: ${themeFontWeights.fontWeightMedium};
                letter-spacing: 0;
                line-height: 1.4375rem;
            }
        `,
    }, 
};

const CardNumberTokenExFrameWrapper = styled.div<InjectableCss>`
    ${({ css }) => css}
`;
const SecurityCodeTokenExFrameWrapper = styled.div<InjectableCss>`
    ${({ css }) => css}
`;
const SecurityCodeImageWrapper = styled.div<InjectableCss>`
    ${({ css }) => css}
`;

const PaymetricIframe = styled.iframe<InjectableCss>`
    ${({ css }) => css}
`;

const CreditCardDetailsEntry = ({
    useTokenExGateway,
    iframe,
    paymetricFrameRef,
    isTokenExIframeLoaded,
    extendedStyles,
    canSaveCard,
    saveCard,
    onSaveCardChange,
    cardHolderName,
    cardHolderNameRef,
    onCardHolderNameChange,
    cardHolderNameError,
    cardNumberError,
    cardNumber,
    cardNumberRef,
    onCardNumberChange,
    possibleCardType,
    onCardTypeChange,
    cardTypeError,
    cardType,
    cardTypeRef,
    availableCardTypes,
    expirationMonth,
    expirationMonthRef,
    onExpirationMonthChange,
    expirationError,
    availableMonths,
    expirationYear,
    expirationYearRef,
    onExpirationYearChange,
    availableYears,
    securityCodeError,
    securityCode,
    securityCodeRef,
    onSecurityCodeChange,
    cardModalOpen,
    currentUserIsGuest, 
    cartState,   
}: Props) => {
    const { value: cart } = cartState;
    const paymentOptions = cart ? cart.paymentOptions : undefined;
    const paymentMethods = paymentOptions ? paymentOptions.paymentMethods : undefined;
    const isCreditCard=paymentMethods?.find(x=>x.cardType!==null);

    const [isSecurityCodeModalOpen, setIsSecurityCodeModalOpen] = useState(false);
    const [styles] = React.useState(() => mergeToNew(creditCardDetailsEntryStyles, extendedStyles));

    const handleSecurityCodeHelpLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        setIsSecurityCodeModalOpen(true);
    };

    const handleSecurityCodeModalClose = (_: React.SyntheticEvent<Element, Event>) => setIsSecurityCodeModalOpen(false);

    const securityCodeLabel = translate("Locate my card's security code");

    const resolvedShouldUseTokenEx = iframe === "TokenEx" || useTokenExGateway;

    return (
        <GridContainer {...styles.creditCardDetailsContainer} data-test-selector="creditCardDetailContainer">
            <GridItem {...styles.creditCardDetailsHeadingGridItem}>
            <Typography {...styles.selectCard} as="div">
                <Typography {...styles.titleContainer} as="div">
                <h3 className="card-heading">{translate("Card Information")}</h3>

                {!currentUserIsGuest && paymentMethods && paymentMethods.length > 0 && typeof isCreditCard!=="undefined" && (
                    <Link
                        {...styles.selectCardAddressLink}
                        type="button"
                        data-test-selector="checkoutBilling_selectCard"
                        onClick={() => cardModalOpen(true)}
                    >   
                        <Typography className="select-card">{translate("Select saved credit card")}</Typography>
                        <Icon src={EditIcon} />
                    </Link>
                )}
                </Typography>
            </Typography>
            </GridItem>
            {canSaveCard && (
                <GridItem {...styles.saveCardGridItem}>
                    <CheckboxGroup {...styles.saveCardCheckboxGroup}>
                        <Checkbox {...styles.saveCardCheckbox} checked={saveCard} onChange={onSaveCardChange}>
                            {translate("Save card information")}
                        </Checkbox>
                    </CheckboxGroup>
                </GridItem>
            )}
            {iframe === "Paymetric" ? (
                <GridItem {...styles.paymetricGridItem}>
                    <PaymetricIframe id="paymetricIframe" ref={paymetricFrameRef} {...styles.paymetricIframe} />
                </GridItem>
            ) : (
                <>
                    <GridItem {...styles.cardNumberGridItem}>
                        {resolvedShouldUseTokenEx ? (
                            <TokenExFrame
                                {...styles.cardNumberTokenExFrame}
                                label={translate("Card Number")}
                                tokenExIFrameContainer={
                                    <CardNumberTokenExFrameWrapper
                                        {...styles.cardNumberTokenExFrameWrapper}
                                        id="tokenExCardNumber"
                                    />
                                }
                                disabled={!isTokenExIframeLoaded}
                                required
                                error={cardNumberError}
                                data-test-selector="checkoutReviewAndSubmit_cardNumber"
                            />
                        ) : (
                            <TextField
                                {...styles.cardNumberText}
                                label={translate("Card Number")}
                                value={cardNumber}
                                onChange={onCardNumberChange}
                                required
                                maxLength={16}
                                error={cardNumberError}
                                data-test-selector="checkoutReviewAndSubmit_cardNumber"
                                ref={cardNumberRef}
                            />
                        )}
                    </GridItem>
                    <GridItem {...styles.cardHolderNameGridItem}>
                        <TextField
                            {...styles.cardHolderNameText}
                            label={translate("Name on Card")}
                            value={cardHolderName}
                            onChange={onCardHolderNameChange}
                            required
                            maxLength={30}
                            error={cardHolderNameError}
                            data-test-selector="checkoutReviewAndSubmit_cardHolderName"
                            ref={cardHolderNameRef}
                        />
                    </GridItem>
                    <GridItem {...styles.expirationDateGridItem}>
                        <GridContainer {...styles.expirationDateContainer}>
                            <GridItem {...styles.expirationMonthGridItem}>
                                <Select
                                    {...styles.expirationMonthSelect}
                                    label={translate("Exp. Month")}
                                    value={expirationMonth}
                                    onChange={onExpirationMonthChange}
                                    required
                                    error={expirationError}
                                    data-test-selector="checkoutReviewAndSubmit_expirationMonth"
                                    ref={expirationMonthRef}
                                >
                                    {availableMonths.map(month => (
                                        <option key={month.value} value={month.value}>
                                            {month.key}
                                        </option>
                                    ))}
                                </Select>
                            </GridItem>
                            <GridItem {...styles.expirationYearGridItem}>
                                <Select
                                    {...styles.expirationYearSelect}
                                    label={translate("Exp. Year")}
                                    value={expirationYear}
                                    onChange={onExpirationYearChange}
                                    required
                                    data-test-selector="checkoutReviewAndSubmit_expirationYear"
                                    ref={expirationYearRef}
                                >
                                    {availableYears.map(year => (
                                        <option key={year.value} value={year.value}>
                                            {year.key}
                                        </option>
                                    ))}
                                </Select>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.securityCodeGridItem}>
                        {resolvedShouldUseTokenEx ? (
                            <>
                                <TokenExFrame
                                    {...styles.securityCodeTokenExFrame}
                                    label={translate("Security code")}
                                    tokenExIFrameContainer={
                                        <SecurityCodeTokenExFrameWrapper
                                            {...styles.securityCodeTokenExFrameWrapper}
                                            id="tokenExSecurityCode"
                                        />
                                    }
                                    disabled={!isTokenExIframeLoaded}
                                    required
                                    error={securityCodeError}
                                    data-test-selector="checkoutReviewAndSubmit_securityCode"
                                />
                                <Typography {...styles.securityLabel} className="securitylabel">
                                    <Typography as="span" {...styles.tooltipIcon}
                                        onClick={handleSecurityCodeHelpLinkClick}
                                        tabIndex={0}
                                        className="security-link"
                                    >
                                        <Icon src={InfoNewIcon} />
                                    </Typography>
                                </Typography>
                            </>
                        ) : (
                            <>
                            <TextField
                                {...styles.securityCodeText}
                                label={translate("Security code")}
                                value={securityCode}
                                onChange={onSecurityCodeChange}
                                required
                                minLength={3}
                                maxLength={4}
                                error={securityCodeError}
                                data-test-selector="checkoutReviewAndSubmit_securityCode"
                                ref={securityCodeRef}
                            />
                                <Typography {...styles.securityLabel} className="securitylabel">
                                    <Typography as="span" {...styles.tooltipIcon}
                                        onClick={handleSecurityCodeHelpLinkClick}
                                        tabIndex={0}
                                        className="security-link"
                                    >
                                        <Icon src={InfoNewIcon} />
                                    </Typography>
                                </Typography>
                            </>
                        )}
                        <Modal
                            headline={securityCodeLabel}
                            isOpen={isSecurityCodeModalOpen}
                            handleClose={handleSecurityCodeModalClose}
                            {...styles.securityCodeHelpModal}
                        >
                            <SecurityCodeImageWrapper {...styles.securityCodeHelpModalImageWrapper}>
                                <LazyImage
                                    src="/images/security_code_sample.jpg"
                                    imgProps={{ width: 660, height: 264 }}
                                    altText={translate("Location of security code on card")}
                                    {...styles.securityCodeHelpImage}
                                />
                            </SecurityCodeImageWrapper>
                        </Modal>
                    </GridItem>
                </>
            )}
        </GridContainer>
    );
};

export default connect(mapStateToProps)(CreditCardDetailsEntry);